<div class="cr-option-item">
  <i
    *ngIf="multiple && selected"
    class="icon-alert-close"></i>
  <i
    *ngIf="multiple && !selected"
    class="icon-plus-sign"></i>
  <ng-content></ng-content>
</div>
